const locale = {
  NAV: {
    HOME: "Home",
    APPLY: "Apply",
    HOW_IT_WORKS: "How it works",
    ABOUT: "About",
    FINANCIAL_PRODUCT: "Financial product",
    CONTACT: "Contact",
    FAQS: "FAQs",
  },
  SIGN_IN: {
    LOGIN: "LOG IN",
    TITLE: "LOGIN",
    DESCRIPTION: "QUICK, SAFE AND CONVENIENT",
    FIELDS: {
      ID: "National ID/ Iqama",
      PASSWORD: "Password",
    },
    FORGOT_PASSWORD: "Forgot password?",
    DONT_HAVE_AN_ACCOUNT: "ALREADY HAVE AN ACCOUNT?",
    SIGN_UP: "SIGN UP",
    ID_10_DIGITS: "ID must be exactly 10 digits.",
    CANNOT_BE_EMPTY: "Cannot be empty.",
    CREDENTIAL_SUCCESS: "Credentials verified successfully",
    SOMETHING_WENT_WRONG: "Something went wrong",
    TIMEOUT: "Timeout. Please, sign-in again",
    VERIFICATION_COMPLETE: "Verification complete",
    WRONG_OTP: "Wrong OTP!",
    SEND: "Send",
    RESEND_CODE: "Resend code",
    WE_HAVE_SENT: "We've sent your one-time password (OTP) by SMS",
    HELP_LINE_CALL: "Call for support: 920005477",
    OR: "OR",
    HELP_LINE_EMAIL: "email us at: info@tamweel-aloula.com",
    INVALID_CREDENTIALS: "Invalid credentials (ID or password).",
    ACCOUNT_DELETED: "Account has been deleted.",
    // ACCOUNT_LOCKED: '',
    DEVICE_REGISTRATION_LIMIT_REACHED:
      "Device registration limit has been met.",
    IVR_NOT_VERIFIED: "Device is not verified on call.",
    DEVICE_NOT_REGISTERED: "This device is not registered.",
    // OTP_SEND_FAILED: '',
    LOGIN_FAILED: "An unexpected error occurred, Please try again later.",
    HELP_AND_SUPPORT: "Help And Support",
  },
  SIGN_UP: {
    TITLE: "SIGN UP",
    DESCRIPTION: "A step closer to financial solutions",
    FORM_DESCRIPTION: "Please, fill-out the following form",
    HELP_LINE:
      "Call for support: 920005477 or email us at: info@tamweel-aloula.com",
    DONE: "Ok",
    PRIVACY: {
      TITLE: "Privacy notice",
    },
    LABELS: {
      ID: "National ID/ Iqama",
      PHONE: "Phone number registered in Absher",
      EMAIL: "Email",
      CONFIRM_EMAIL: "Confirm Email",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
    },
    FIELDS: {
      ID: "ID",
      PHONE: "9665XXXXXXXX",
      EMAIL: "Email",
      CONFIRM_EMAIL: "Confirm Email",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      HIJRI_DATE: "Hijri Date Of Birth",
      GEORGIAN_DATE: "Georgian Date Of Birth",
      SELECT_DATE_TYPE: "Select Date Type",
    },
    TERMS_AGREE: "I have read and agreed to the",
    TERMS_MODEL: {
      TITLE: "Terms and Conditions",
      CONTENT: `
    I, the applicant customer, and I have full legal capacity, acknowledge that I have read and agreed to the conditions for providing the service below, and to consider these conditions as an integral part of the service request under my consent, which is interpreted by the signature of a binding and due diligence. I, the service applicant, acknowledge that all correct data, information and documents have been provided through this service and bear all the consequences thereof. 1. User: means the customer or person authorized by the customer and authorized by the company to enter to provide data and documents on the product order. 2. The company is committed to implementing all instructions and transactions received from the user electronically, provided that they are compatible with the company's work system, the instructions of the competent official authorities and the financing laws at its absolute discretion. 3. This service is done electronically using digital authentication and may not be challenged electronically. 4. The Company has the right to restrict any operations carried out by the User electronically to the Contract and the Client is obliged to pay the fees determined by the Company for the use of this Service, which may be amended from time to time at its absolute discretion. 5. I, the applicant, acknowledge the electronic responsibility, and full responsibility of the person authorized by me to use the electronic services and conduct full transactions through the user and the password and everything related to the requirements of maintaining them, and not to disclose the number to any party, even the company's employee or any other person or entity. 6. I, the applicant, acknowledge that the Company, its affiliates and the Company's employees are not responsible for any losses, damages, financial claims or otherwise resulting from the use of the user's account and my password, and I am obligated to notify the Company immediately upon the occurrence of anything contrary by a notarized letter from me of the incident if it becomes clear to me that the password has become known to others so that the Company can take the necessary action, I shall be responsible for all transactions and instructions issued by the user's account until the company receives the written communication and obtains a written statement from it. 7. I, the applicant, acknowledge the full confidentiality of the user's account, information and financing transactions, and I am responsible for any unauthorized use and bear all the consequences that may result from this, whether direct or indirect. 8. I, the applicant, acknowledge that the intellectual property rights of the software and documents of the electronic services provided are not owned and agree not to allow me as a user to copy, modify the programs, etc., or to download or transfer the electronic services programs to a similar website. 9. I, the applicant, acknowledge the possibility of viewing the status of the application and knowing the status (acceptance or rejection) through this service, and I also acknowledge that the company has no obligations when the application is not accepted for any reason. 10. The company has the right to cancel the required service at any time without prior notice if it is found that the information or documents provided are incorrect or incompatible with the internal terms and conditions of the company or external to the relevant authorities. 11. I agree to receive all correspondence and notifications related to the request submitted by me by e-mail, text messages and contact, and commit to taking all necessary precautions for the confidentiality of correspondence, and I am responsible for any violations that may result from this. 12. I acknowledge the company's right to record all communications and instructions received through the electronic services, and that these audio recordings are evidence of the information contained therein in the event of using the toll-free number or the customer services department. 13. I agree to provide Tamweel Al Oula with any information or data you request from me to establish my account with the Company, to review or to administer and authorize the Company to obtain the necessary or necessary information concerning me or my said account or any other account that the Company has, from the Saudi Credit Bureau (SIMAH). I also agree that the Company may disclose my information in my said account or any other account authorized by the Saudi Credit Bureau (SIMAH) through the Information Sharing Agreement or to any other party approved by the Central Bank (SAMA). He also recognized the legitimacy of the sources of income used to deal with the financing of the former. 14. I, the applicant, acknowledge that any delay caused by the Company to claim any right or authority contained in these Terms shall not be considered a waiver of such right or power and the Company shall have the right to claim it at any time. 15. I, the applicant, acknowledge that the Company reserves the right to amend these Terms, and the continued use of the User by me constitutes my acceptance of the amendment. 16. These Terms shall be implemented and interpreted in accordance with the provisions of the laws and regulations in force in the Kingdom of Saudi Arabia, and all that is not provided for shall be in accordance with Saudi regulations and disputes related to this service shall be resolved before the competent Saudi courts. 17. The customer "applicant" acknowledges during the period of submitting the financing application with Tamweel Al Oula Company and until obtaining this not to apply with any other party to obtain financing or any financial obligation, which may affect his credit history, and also acknowledges and undertakes his commitment to the regulations, controls and instructions of the Saudi Central Bank and all other legislative controls, In case of violation, Tamweel Al Oula Company has the right to refuse to grant him the required financing and sue the customer "applicant" with any official authority and claim any amounts, fees or compensation that may result from submitting this application. 18. The customer also acknowledges and undertakes to bear full responsibility for submitting the financing application with Tamweel Al Oula Company and after obtaining credit approval when submitting the financing application and approving it by granting it to the financing product provided by him, and acknowledges his full knowledge of the consequences of exceeding the debt burden ratio permitted by law during the period of validity of the financing contract and for all that results from such override and acknowledging that in the event that it occurs to the customer, by submitting financing applications with other financing bodies and obtaining simultaneously or at any time later additional loans that exceed the total obligations of his total obligations beyond the permissible limit, he bears full responsibility for what has been submitted and is considered a breach of the contractual terms with a finance company and thus bears the payment of the full amount agreed upon in the contract, and the company reserves the right to claim immediately and pay the full amount.
    `,
      ACTION: "Agree",
      ACCEPTED: "Accepted",
    },
    NATIONAL_INFORMATION_ACCEPTENCE:
      "Allow usage of services of the National Information Center for identity verification.",
    ALREADY_ACCOUNT: "Already have an account?",
    NEWS_AND_OFFERS_CONSENT:
      "I would like to receive the latest news and personalized offers from Tamweel Aloula",
    SIGN_IN: "SIGN IN",
    FROM_BUTTON: "Continue",
  },
  COMPLAINTS: {
    TITLE: "Help and support",
    COMPLAINT_SUBMISSION: "Complaint Submission",
    COMPLAINT_DESC: "Please fill out the form below to submit your complaint.",
    FIELDS: {
      FULL_NAME: "Full Name",
      ID: "National ID/ Iqama",
      EMAIL: "Email",
      PHONE: "Phone Number",
      COMPLAINT_DETAILS: "Complaint Details",
      CITY: "City",
    },
    PLACEHOLDERS: {
      FULL_NAME: "EX. Ahmed",
      ID: "EX: 25174XXXXX",
      EMAIL: "EX: Name@mail.com",
      PHONE: "EX: 96645555555",
      COMPLAINT_DETAILS: "please describe your problem...",
      CITY: "EX: Riyadh",
    },
    VERIFY: "Verify Phone Number",
    VERIFY_DESC: "We sent your one-time password (OTP) by SMS",
    VALIDATE: "Validate OTP",
    SUBMIT: "Submit Complaint",
    PHONE_VERIFIED: "Phone number verified!",
    VALIDATION: {
      NAME_MAX_LENGTH: "Name must be less than 100 characters",
      TIMEOUT: "Your OTP has timed out!",
      NAME_ONLY_LETTERS: "Name must contain only letters",
      NAME_REQUIRED: "Name is required",
      PHONE_FORMAT: "Phone number must be 9665XXXXXXXX",
      PHONE_REQUIRED: "Phone number is required",
      EMAIL_FORMAT: "Email must be in the format of Name@mail.com",
      EMAIL_MAX_LENGTH: "Email must be less than 55 characters",
      EMAIL_REQUIRED: "Email is required",
      DETAILS_MAX_LENGTH: "Details must be less than 4000 characters",
      DETAILS_ALLOWED_CHARS:
        "Details must contain Arabic or English letters, numbers, spaces, commas, and periods",
      DETAILS_REQUIRED: "Details are required",
      ID_FORMAT: "ID must be 10 digits",
      ID_REQUIRED: "ID is required",
      ID_START_WITH: "ID must start with 1 or 2",
      CITY_MAX_LENGTH: "City must be less than 100 characters",
      CITY_ONLY_LETTERS: "City must contain only letters",
    },
    SUBMITTED: "Submit!",
    SUCCESS_PARA1: "Your complaint has been submitted successfully.",
    SUCCESS_PARA2: "We will review it and get back to you shortly.",
    BACK: "Back to Login",
  },
  HOME: {
    LAST_LOGIN: "Last login",
    CREATE_NEW: "Apply Now",
    REQUEST: "REQUEST",
    APPL_NO: "Application No",
    PRODUCT: "Product",
    CONTRACT: "Contract",
    STATUS: "Status",
    VIEW: "View application",
    COMPLETE: "Complete Request",
    SEARCH: "Search name, amount, etc.",
    ARE_YOU_SURE: "Are you sure you want to logout?",
    Hi: "Hi",
    DIGITAL_APP_ID: "New Digital Appl ID",
    CONTRACT_SIGNING: "Contract signing",
    VIEW_CONTRACT: "View Contract",
    UPLOAD_DOCUMENT: "Upload Document",
    APPLICATION_TIME_LINE: "Application Timeline",
    VIEW_OFFER: "View offer",
    NO_REQUESTS: "No requests yet",
    EXPLORE_SERVICES: "Explore Our Services & Apply:",
    AUTO: "Auto Leasing",
    PERSONAL: "Personal Financing",
    AUTO_DESC:
      "Compatible With Islamic Law And With A Competitive Profit Margin",
    PERSONAL_DESC:
      "Compatible With Islamic Law And With A Competitive Profit Margin",
    PRODUCT_TITLE: "Tamweel Finance Product",
    SCHOOL_PRODUCTS_TITLE: "Tamweel School Product",
    CARDS_TITLE: "Tamweel Voucher Cards",
    SCHOOL_ALHASA: "Kifah School Al-Hasa",
    SCHOOL_KHOBAR: "Kifah School Al-Khobar",
    SCHOOL_RIYADH: "Kifah School Al-Riyadh",
  },
  CREATE_REQUEST: {
    OF: "of",
    STEPS: "Steps",
    AUTO: "Auto Loan",
    CANCEL: "Cancel",
    CANCEL_REQUEST: "Cancel request?",
    CONFIRM: "Confirm",
    ARE_YOU_SURE_REQUEST: "Are you sure you want to cancel the request?",
    DOCUMENT: "Document",
    CLICK_TO_UPLOAD: "Click to upload file",
    EMPLOYMENT_DETAILS: "Employment Details",
    FINANCIAL_DETAILS: "Financial Details",
    NEXT: "Next",
    SALES_REFERENCE: "Sales Reference",
    DO_YOU_SALE_REFERENCE: "Do you have a sales person reference?",
    EXACTLY_8_ALLOWED: "Exactly 8 digits are allowed.",
    SALES_PERSON_REF: "Sales person reference",
    LOAN_DETAILS: "Loan Details",
    PERSONAL_DETAILS: "Personal Details",
    GREAT: "Great!",
    YOUR_REQUEST: "Your request has been",
    SUBMITTED_FOR_REVIEW: "submitted for review.",
    THANKS_FOR_APPLYING: "Thank you for applying.",
    APP_NO: "Application number",
    FEEDBACK: "Your feedback helps us make things better!",
    THANKS_FOR_FEEDBACK: "Thanks for your feedback",
    WRITE_COMMENT: "Write Your Comment",
    ADD_COMMENT: "Add Comment",
    COMMENT_SUB: "Feel free to say how was your journey",
    ONLY_ONE_MINUTE: "This will only take a minute.",
    DONE: "Done",
    WE_WILL_GET_BACK: "We will get back to you soon.",
    KINDLY_MESSAGE: "Kindly contact our sales team",
    FURTHER_ASSISTANCE: "920005477 for further assistance.",
    Full_Name: "Full Name",
    Street_Name: "Street Name",
    Building_Num: "Building Number",
    Additional_Num: "Additional Number",
    District_Name: "District Name",
    Post_Code: "Post Code",
    street_name_required: "Street name is required",
    buildingnum_required: "Building number is required",
    additional_name_required: "Additional number is required",
    District_name_required: "District name is required",
    Post_code_required: "Post code is required",
    Post_code_only_number: "Post code must be a number",
    building_num_only_number: "Building number must be a number",
    Post_code_six_digits: "Post code cannot exceed 6 digits",
    Post_code_six_digits_min: "Post code cannot be less than 6 digits",
    ID_Expiry_Date: "ID Expiry Date",
    IBAN: "IBAN",
    Gender: "Gender",
    Employment_type: "Employment type",
    Education_Level: "Education Level",
    Resident_Status: "Resident Status",
    Employment_Sector: "Employment Sector",
    Occupation: "Occupation",
    Joining_Date: "Joining Date",
    PEP_Relation:
      "Are you politically exposed person, or do you have a relationship with a politically exposed person(PEP)?",
    Real_Benificiary: "Are you the real beneficiary from the finance?",
    Real_Benificiary_Name: "Real benificiary name",
    Related_Party:
      "Do you have a first-degree relationship with a board member, committee members or senior executives?",
    Party_Postion: "Position",
    pep_relation_required: "This field is required",
    real_benificiary_required: "This field is required",
    related_party_required: "This field is required",
    party_position_required: "This field is required",
    Type_of_loan: "Type of loan",
    Facility: "Facility",
    Requested_loan_amount: "Requested loan amount",
    SalesRef: "Sales Reference ID (Optional)",
    Tenure: "Tenure (in months)",
    Food_expenses: "Food expenses",
    Housing_expenses: "Housing expenses",
    Domestic_workers: "Domestic workers",
    Education_expenses: "Education expenses",
    Health_care_expenses: "Health care expenses",
    Communication_and_transportation_expenses:
      "Communication and transportation expenses",
    Insurance_expenses: "Insurance expenses",
    Any_expected_future_expenses: "Any expected future expenses",
    Total_expenses: "Total expenses",
    Asset_manufacturer: "Vehicle manufacturer",
    Asset_model: "Vehicle model",
    Asset_model_type: "Vehicle model type",
    Asset_color: "Vehicle color",
    Asset_condition: "Vehicle condition",
    Asset_price: "Vehicle price",
    Asset_model_year: "Vehicle model year",
    Down_payment: "Down payment",
    Ballon_payment: "Ballon payment",
    Dealer_name: "Dealer name",
    Document: "document",
    First_name: "First name",
    Middle_name: "Middle name",
    Family_name: "Family name",
    ID_type: "ID type",
    ID: "ID",
    ID_number: "ID number",
    Phone: "Phone",
    Email: "Email",
    Select_Marital: "Select your marital status.",
    Pick_Dependents: "Pick the number of dependents.",
    CANNOT_BE_EMPTY: "Cannot be empty.",
    Only_Arabic: "Only Arabic allowed.",
    MAX_12_MONTHS: "Must be less than or equal 12 months",
    MAX_36_MONTHS: "Must be less than or equal 36 months",
    MAX_60_MONTHS: "Must be less than or equal 60 months",
    IBAN_22: "IBAN must be 22 integers long.",
    IBAN_ONLY_NUMBERS: "IBAN must contain only numbers.",
    MUST_BE_INTEGER: "Must be an integer",
    MUST_BE_ATLEAST: "Must be at least 25,000",
    MUST_BE_ATLEAST_3000: "Must be at least 3000",
    MUST_BE_ATLEAST_5000: "Must be at least 5000",
    MUST_BE_ATLEAST_3500: "Must be at least 3500",
    MUST_BE_8_DIGITS: "Must be atleast 8 digits",
    MUST_BE_BETWEEN_8_AND_10_DIGITS: "Must be between 8 to 10 digits",
    CANNOT_EXCEED: "Cannot exceed 7 digits",
    CANNOT_EXCEED_500000: "Cannot exceed more than 500000",
    CANNOT_EXCEED_50000: "Cannot exceed more than 50000",
    CANNOT_EXCEED_4: "Cannot exceed 4 digits",
    MUST_BE_ATLEAST_0: "Must be at least 0",
    CANNOT_EXCEED_7: "Cannot exceed 7 digits",
    CANNOT_EXCEED_50: "Cannot exceed 50 characters.",
    DOWN_PAYMENT_20:
      "Down payment should be 3K or above or it can be zero And should less than Vehicle Price",
    BALLON_PAYMENT_40: "Ballon Payment must be 40% or less than assetPrice",
    BALLON_REQUIRED: "Ballon Payment is required",
    DOWN_PAYMENT_REQUIRED: "Down Payment is required",
    NAME_REQUIRED: "Name is required.",
    PHONE_REQUIRED: "Phone is required.",
    YOUR_NAME: "Your name",
    PLEASE_ENTER_NAME: "Please enter your name",
    YOUR_EMAIL: "Your email",
    USE_VALID_EMAIL: "Use a valid email",
    PLEASE_TYPE_EMAIL: "Please type your email",
    YOUR_GENDER: "Your gender",
    PLEASE_SELECT_GENDER: "Please select your gender",
    DO_YOU_HAVE_DEPENDENTS: "Do you have dependents?",
    NUMBER_OF_DEPENDENTS: "Number of dependents",
    LOADING_DETAILS: "Loading personal details...",
    LOADING_ADDRESS_DETAILS: "Loading address details...",
    LOADING_MARITAL_DETAILS: "Loading marital details...",
    LOADING_EMPLOYMENT_DETAILS: "Loading employment details...",
    LOADING_LOAN_DETAILS: "Loading loan details...",
    LOADING_FINANCIAL_DETAILS: "Loading financial details...",
    LOADING_AUTOLOAN_DETAILS: "Loading autoloan details...",
    LOADING_DOCUMENT_DETAILS: "Loading document details...",
    LOADING_ASSET_DETAILS: "Loading asset details...",
    City: "City",
    Marital_status: "Marital Status",
    Region: "Region",
    Title: "Title",
    Nationality: "Nationality",
    Number_of_dependents: "Number of dependents",
    Male: "Male",
    Femail: "Female",
    undefined: "",
    DOC_CONDITION_1: "Please attach the salary certificate",
    DOC_CONDITION_2: "Please attach the bank statement for the last 3 months",
    DOC_CONDITION_3:
      "If the requested amount for finance is 40,000 riyals or more",
    MAX_FILES_UPLOADED: "Maximum number of files uploaded.",
    LOAN_REASON: "Reason of Loan",
    LOAN_REASON_REQUIRED: "Loan reason is required",
    MANAGE_OFFERS_DES: "Receive the latest news and personalized offers",
  },
  FORGOT_PASSWORD: {
    "Reset password": "Reset password",
    "Forgot password?": "Forgot password?",
    "Please, enter your phone": "Please, enter your phone",
    Send: "Send",
    "Return to sign in": "Return to sign in",
    "Cannot be empty": "Cannot be empty.",
    "Must be exactly 9 digits": "Must be exactly 9 digits",
    FORGOT_PASSWORD_LABEL: "Phone number registered in Absher",
    ONE_TIME_OTP: "We've sent your one-time password (OTP) by SMS",
    ONE_TIME_PASS: "Please, enter your new password",
    RESET: "Reset",
    PASSWORD: "Password",
    CONFIRM_PASSWORD: "Confirm Password",
  },
  City: "City",
  Marital_status: "Marital Status",
  Region: "Region",
  Title: "Title",
  Nationality: "Nationality",
  Number_of_dependents: "Number of dependents",
  Male: "Male",
  Femail: "Female",
  Employment_type: "Employment Type",
  Education_Level: "Education Level",
  Resident_Status: "Resident Status",
  Employment_Sector: "Employment Sector",
  Joining_Date: "Joining Date",
  "Select date": "Select date",
  "No Data": "No Data",
  "For Private Sector": "For Private Sector",
  APPLICATION_ALREADY_EXISTS: "You have application already exists",
  APPLICATION_ALREADY_SUBMITTED: "Your application is already submitted",
  OFFER_PENDING_GENERATION: "Offer is pending generation.",
  CONTRACT_PENDING_GENERATION: "Contract is pending generation.",
  "Something went wrong": "Something went wrong",
  USER_ALREADY_EXISTS: "You already have an account, please login",
  DEVICE_ALREADY_REGISTERED: "please use your device for registration",
  OFFER: {
    Offering: "Offering",
    Product: "Product",
    KASTLENO: "Kastle App No",
    CUSTOMERNAME: " Customer Name",
    ERRORLOADING: "Error loading Offer",
    NO_DATA_ALLOWED_ERR: "No data found for this segment.",
  },
  OFFER_TABLE: {
    APP_NO: "Application number",
    PRODUCT_NAME: "Product name",
    CONTRACT: "Contract",
    STATUS: "Status",
    OFFER: "Offer",
    REFRESH: "Refresh",
    DELETE: "Delete",
    VIEW_CONTRACT: "View Contract",
    EDIT: "Edit",

    CONFIRM: "Confirm?",
    CONFIRM_BTN: "Confirm",
    CANCEL: "Cancel?",
    CANCEL_BTN: "Cancel",
    CONFIRM_ACCEPTANCE: " Confirm Contract Acceptance?",
    CONFIRM_REJECTION: " Confirm Contract Rejection?",
    ACCEPT: "Accept",
  },
  CONTRACT: {
    CONTRACT: "CONTRACT",
    CONTRACT_ACCEPT: "Contract Accepted",
    CONTRACT_REJECT: "Contract Rejected",
    CONTRACT_ACCEPTANCE: "Do you confirm contract acceptance?",
    CONTRACT_ERROR: "Failed to accept the contract, please try again",
    CONTRACT_ERROR_REJECT: "Failed to reject the contract, please try again",
    CONFIRM: "Confirm",
    REJECT: "reject",
    CONFIRM_QUESTION: "Confirm?",
    REJECT_QUESTION: "Reject Contract?",
    CONFIRM_REJECTANCE: "Do you confirm contract rejection?",
  },
  PRODUCTS: {
    AUTO_DESC_SUB:
      "Auto lease financing enables you to own a new or used vehicle through our partnerships with numerous showrooms and agencies, offering flexible installment plans. This Sharia-compliant solution is available to both Saudis and residents of Saudi Arabia, with application options via digital channels or by visiting one of our branches.",
    PERSONAL_DESC_SUB:
      "At tamweel al-oula Financing Company, we strive to provide easy financing solutions that enable everyone to quickly obtain funding. You can now apply for a personal financing product compliant with Islamic Sharia through digital application.",
    SCHOOL_DESC_SUB:
      "Simplify your school fee payments — apply today and spread the cost with easy monthly installments through Tamweel Aloula.",
    AUTO_PT1: "Includes employees and retired individual.",
    AUTO_PT2: "Age of applicant must be between 21 and 60",
    AUTO_PT3: "Minimum salary of 3500 riyals.",
    AUTO_PT4:
      "The minimum financing amount is not less than 20,000 riyals, and the maximum financing amount is 500,000 riyals.",
    AUTO_PT5:
      "Duration of service is at least 4 months for the private sector and at least 3 months for the semi-governmental sector and at least 1 month for the governmental sector.",
    AUTO_PT6:
      "The APR ranges between 10% – 16% (insurance excluded) and varies according to financing amount and repayment period.",
    AUTO_PT7: "The repayment period ranges from 6 months to 60 months.",
    AUTO_PT8: "The percentage of salary deduction is up to 45%.",

    PRSNL_PT1: "Includes employees and retired Saudis.",
    PRSNL_PT2: "Age of applicant must be between 21 and 60.",
    PRSNL_PT3: "Minimum salary of 4100 riyals.",
    PRSNL_PT4:
      "The minimum financing amount is not less than 3,000 riyals, and the maximum financing amount is 500,000 riyals.",
    PRSNL_PT5:
      "Duration of service is at least 4 months for the private sector and at least 3 months for the semi-governmental sector and at least 1 month for the governmental sector.",
    PRSNL_PT6:
      "The APR ranges between 20% – 39% and varies according to financing amount and repayment period.",
    PRSNL_PT7: "The repayment period ranges from 6 months to 60 months.",
  },
  PRODUCT_NAME: "Product name",
  ACTIONS: "Actions",
  DELETE: "Delete",
  REFRESH: "Refresh",
  VIEW_CONTRACT: "View contract",
  REQUEST_DETAILS: {
    DETAILS: "Request details",
    REQUEST_NUMBER: "Request number",
    CUSTOMERNAME: "Full name",
    EMAIL: "Email",
    IDNUMBER: "Iqama Number",
    DATE_OF_EXPIRY: "Expiry Date",
    IBAN: "IBAN",
    GENDER: "Gender",
    MOBILE: "Mobile No.",
    FOOD_EXPENSES: "Food Expenses",
    HOUSING_EXPENSES: "Housing expenses",
    DOMESTIC_WORKERS: "Domestic workers",
    EDUCATION_EXPENSES: "Education expenses",
    HEALTHCARE_EXPENSES: "Health care expenses",
    COMM_TRANS_EXPENSES: "Communication and transportation expenses",
    INSURANCE_EXPENSES: "Insurance expenses",
    FUTURE_EXPENSES: "Any expected future expenses",
    EMPCATID: "Employment type",
    SECTORID: "Employment Sector",
    DATEOFJOINING: "Date of Joining",
    QUALIFICATIONID: "Education Level",
    RESIDENTID: "Resident Status",
    PRODUCTID: "Type of loan",
    SUBPRODUCTID: "Facility",
    REQUESTED_AMOUNT: "Requested loan amount",
    TENURE: "Tenure (in months)",
    ASSET_MANUFACTURER: "Vehcile manufacturer",
    ASSET_MODEL: "Vehcile model",
    ASSET_MODEL_TYPE: "Vehcile model type",
    COLORID: "Vehcile color",
    ASSET_CONDITION: "Vehcile condition",
    ASSET_PRICE: "Vehcile price",
    ASSET_MODEL_YEAR: "Vehcile model year",
    DOWN_PAYMENT: "Down payment",
    BALLOON_PAYMENT: "Balloon payment",
    DEALERID: "Dealer name",
  },
  VIEW_OFFER: {
    FINANCE_AMOUNT: "Finance Amount",
    DOWN_PAYMENT: "Down Payment",
    BALLOON_PAYMENT: "Balloon Payment",
    EMI: "EMI",
    AGREEMENT_TOTAL: "Agreement Total",
    TENURE: "Tenure",
    NO_DATA_FOUND: "No data found for this segment.",
    APR: "APR",
  },
  LOADING: "Loading...",
  SETTINGS: {
    USER_PROFILE: "User Profile",
    Full_Name: "Full Name",
    Address: "Address",
    Birth_Date: "Birth Date",
    Mobile_Number: "Mobile Number",
    RESET_PASSWORD: "Reset Password",
    SUBMIT: "Submit",
    OLD_PASSWORD: "Old Password",
    PLEASE_ENTER_OLD_PASSWORD: "Please enter your old password",
    NEW_PASSWORD: "New Password",
    PLEASE_ENTER_NEW_PASSWORD: "Please enter your new password",
    PASSWORDS_MUST_MATCH: "Passwords must match",
    PLEASE_CONFIRM_PASSWORD: "Please enter confirm password",
    CONFIRM_PASSWORD: "Confirm Password",
    WE_HAVE_SENT: "We've sent your one-time password (OTP) by SMS",
    ENTER_OTP: "Enter OTP",
    SUBMIT_OTP: "Submit OTP",
    //new setting design text
    SETTINGS: "Settings",
    PERSONAL_DATA: "Personal Data",
    PERSONAL_DATA_DES: "Manage your Name and ID Number... etc",
    ADDRESS_DETAILS: "Address Details",
    ADDRESS_DETAILS_DES: "Manage your Residence place",
    MARITAL_STATUS: "Marital Status",
    MARITAL_STATUS_DES: "Manage your Marital Status and dependents Number",
    ELIGIBILITY: "Eligibility",
    ELIGIBILITY_DES: "Manage your Employment and payment details",
    DOCUMENT: "Document",
    DOCUMENT_DES: "View All of your document",
    TERMS_AND_CONDITION: "Terms & Condition",
    TERMS_AND_CONDITION_DES: "View tamweel terms and condition",
    MANAGE_OFFERS: "Manage your notifications",
    MANAGE_OFFERS_DES: "Receive the latest news and personalized offers",
    INSTALLMENT_DASHBOARD: "Installment details",
    INSTALLMENT_DASHBOARD_DES:
      "Receive installments paid and non paid installments ",
    INSTLMNT_DASHBOADRD_SUMMARY: "Installment Summary",
    INSTALLMENT_DATA_UNAVAILABLE: "Installment data is unavailable",
    INSTALLMENT_DATA_UNAVAILABLE_DESC:
      "There are currently no installment records available for this application.",
    CHECK_BACK_LATER: "Please check back later.",
    NO_SIGNED_APPLICATIONS_FOUND: "No signed applications found",
    FAQ: "FAQ",
    FAQ_DES: "Manage your Marital Status and dependents NO.",
    HELP_AND_SUPPORT: "Help & Support",
    HELP_AND_SUPPORT_DES: "View tamweel contacts",
    ADDRESS_DETAIL: "Address Detail",
    SAVE: "Save",
    HIJRI_DOB: "Hijri DoB",
    GEORGIAN_DOB: "Georgian DoB",
    GENERAL_INFO: "General Information",
    CUSTOMER_DETAIL: "Customer Details",
    CONTACT_US: "Contact Us",
    CONTACT_DES: "24/7 We will answer your questions and problems",
    CONTACT_CARD1: "Sales Units Number",
    CONTACT_CARD2: "Customer Care Center",
    CONTACT_CARD3: "Email",
    VIEW: "View Document",
    CHANGE_PASSWORD: "Change Password",
    CHANGE_PASSWORD_DES: "Manage you Password",
    LOADING_DOCUMENT: "Loading Document",
    NO_DOCUMENTS_AVAILABLE: "No documents available",
    DOCUMENTS_DRAG_DROP_HEADING: "Click to Upload or drag and drop",
    DOCUMENTS_DRAG_DROP_TEXT:
      "(The customer can uploaded relevant documents when requested, only PDF and .Jpeg .PNG can be uploaded. The size should be within 3MB.)",
    ERROR_FILE_TYPE: "You can only upload JPG/PNG/PDF files!",
    ERROR_FILE_SIZE_3MB: "File must be smaller than 3MB!",
    ERROR_FILE_MULTIPLE_EXT:
      "Files with multiple extensions are not allowed.Please rename the file.",
    ERROR_FILE_NAME_CONTRACT:
      "File name should not contain the word 'contract'.",
    FILE_UPLOAD_ERROR: "Failed to upload file.",
    FILE_UPLOAD_SUCCESS: "File uploaded successfully.",
    ERROR_NO_FILE_ADDED: "No file added.",
    BACK: "Back",
    ALL_RIGHTS_RESERVED: "All rights reserved",
    INSTALLMENT_NUMBER: "Installment Number",
    INSTALLMENT_DUE_DATE: "Due Date",
    INSTALLMENT_AMOUNT: "Installment Amount",
    INSTALLMENT_STATUS: "Status",
    INSTALLMENT_DETAILS: "Installment Details",
    BACK_TO_HOME: "Back to Home",
  },
  VALIDATION: {
    AGE_REQUIREMENT: "You must be at least 18 years old",
    CANNOT_BE_EMPTY: "Cannot be empty",
    INCORRECT_LENGTH: "Incorrect length.",
    ID_STARTS_1_OR_2: "ID must start with 1 or 2.",
    MUST_BE_CHECKED: "Must be checked.",
    EMAILS_DO_NOT_MATCH: "Emails do not match.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    PASSWORD_REQUIREMENTS:
      "Password must have at least 8 characters, Two alphabetic characters; one uppercase and one lowercase, One digit and One special character.",
    INVALID_EMAIL_ADDRESS: "Not a valid email address.",
    INVALID_PHONE_NUMBER: "The phone number is invalid.",
    PHONE_MUST_START_WITH_966: "Phone number must start with 966.",
    FILL_REQUIRED_FIELDS: "Please fill in all required fields.",
    IBAN_VAL_FAILED: "IBAN verification failed. Please enter correct IBAN.",
    IBAN_VAL_SUCCESS: "IBAN successfully verified",
  },
  INPUTS: {
    DAY: "Day",
    MONTH: "Month",
    YEAR: "Year",
  },
  MONTHS: {
    JANUARY: "January",
    FEBRUARY: "February",
    MARCH: "March",
    APRIL: "April",
    MAY: "May",
    JUNE: "June",
    JULY: "July",
    AUGUST: "August",
    SEPTEMBER: "September",
    OCTOBER: "October",
    NOVEMBER: "November",
    DECEMBER: "December",
  },

  privacy_note: {
    title_1: "Privacy notice",
    title: "Privacy notice",
    content:
      'Tamweel Aloula (hereafter referred to as "we" or “our” or "us" or “organization” respects your right to data privacy. In this Notice “You” or “Your” refers to the data subject whose personal data is processed by Tamweel Aloula.\n' +
      "This Privacy Notice (“Notice”) provides information about how Tamweel Aloula handles personal information about you and describes the rights you may have regarding your personal information. This Notice applies to Tamweel Aloula and its online and offline collection, use, and disclosure of personal information.\n" +
      "Tamweel Aloula has an obligation to preserve the confidentiality and privacy of the user's data and information.\n" +
      "Tamweel Aloula shall not collect, process or disclose any personal data or information except in accordance with the specific controls provided in the instructions governing the confidentiality of information issued by the regulatory authorities in the Kingdom like PDPL and NDMO, including all amendments applicable to them from time to time.\n",
  },
  personal_data_collection_processing_disclosures: {
    title: "Personal Data Collection, Processing & Disclosures",
    collection: {
      title: "When does Tamweel Aloula Collect Personal Information About You",
      content:
        "This information is collected when you utilize our services through online and offline channels including the conditions when your personal information is shared by members within Tamweel Aloula.",
    },
    types: {
      title:
        "What Types of Personal Information does Tamweel Aloula Collect and Retain",
      content_1:
        "\tWhen you interact with us, we may collect information to help identify and contact you, including, but not limited to, your name, email address, physical address, telephone number (landline and/or mobile), and ID Number.",
      content_2:
        "\tIf you create an account, we may collect your username, password, date of birth, and National Identification information to provide you with our services.",
      content_3:
        "\tWe also may collect information about the device you use to access our online services. This includes device ID, advertising ID, and browser details while using our online services.",
      content_4:
        "\tWe may collect your IP address and information related to that IP address, such as geographical information and domain information.",
      content_5:
        "\tWe may collect different types of personal information about you from various sources. Given below are the further categories of personal information we may have collected through different sources.",
      content_6:
        "\tWe may collect different types of personal information about you from various sources. Given below are the further categories of personal information we may have collected through different sources.",
    },
  },
  personal_information_collection: {
    title: "Personal Information We Collect and From Whom We Collect It",
    what_we_collect: {
      title: "What We may collect",
      content_1:
        "\tIdentity information (Name including first, last, and/or maiden name, Date of birth, National ID Number, Marital Status)",
      content_2: "\tDemographic Information (age, gender, and nationality)",
      content_3:
        "\tContact information (National address, email address (es), telephone number(s)).",
      content_4:
        "\tCompany information (Name, Address, location, type of assets sold, CR Number, Phone numbers, Emails, Websites, Financial Statements, Income, and market value of the land).",
      content_5: "\tInformation collected via cookies.",
      content_6:
        "\tProfessional Employment details (Employment Dates, Employer Name, Employer Information)",
      content_7:
        "\tFinancial details (Bank account details, financial statements, income, credit history, loan or credit application data, Salary information)",
      content_8:
        "\tAudio and electronic recording, for example, when you call in with a question to customer service.",
      content_9: "o\tVideo recording for service delivery purposes.",
    },
    from_whom: {
      title: "From Whom We Collect It",
      content_1: "\tInformation you provide.",
      content_2:
        "\tYour information from member organizations (Banks, Lending organizations, Insurance providers, Telecommunication companies), and from Private companies with national ownerships such as ELM and SIMAH.",
    },
    purpose: {
      title:
        "We collect your personal information for different purposes as mentioned below:",
      content_1:
        "\tFor customer onboarding purposes / customer registration purposes.",
      content_2: "\tTo verify your identity.",
      content_3: "\tFor processing loan or insurance application.",
      content_4:
        "\tTo prevent fraud and unauthorized disclosures of your personal information.",
      content_5:
        "\tTo record and demonstrate how we have conducted the dispute and complaint resolution process and arrived at a resolution.",
      content_6:
        "\tTo comply with business, legal, and regulatory requirements incumbent upon Tamweel Aloula.",
      content_7:
        "\tFor product development and research, and for any purpose subject to the limitations set forth in this Notice and applicable laws incumbent upon Tamweel Aloula.",
      content_8:
        "\tFor fulfillment of your requests, transactional and other communications about our websites and online services.",
      content_9:
        "Your personal data except sensitive data may be used for marketing purposes. ",
      content_10:
        "Your personal data may be used for Automated decision-making. ",
    },
  },
  data_retention: {
    title: "How Long Does Tamweel Aloula Keep Personal Information?",
    content:
      "We will keep your information in accordance with the PDPL regulations or as long as we need it for legal and regulatory purposes as instructed by the regulatory authority, i.e., SAMA. <br> We will actively review the information we hold and delete it securely when there is no longer a legal or regulatory need for it to be retained.",
  },
  data_sharing: {
    title: "With whom does Tamweel Aloula share Your Personal Information?",
    content:
      "Tamweel Aloula shares your personal information with different member organizations including identity verification authorities, financial investigation companies, banks, credit history service providers, trusted cloud service providers, and KSA regulatory authorities to whom you consent to disclose your personal data. Prior to sharing personal data with these member organizations, we review the services performed by such member organizations and require that the member organizations keep personal data confidential and secure and not use it for any purpose except performing the services. Disclosure for Legal reasons: We may share personal data with third parties to comply with valid legal requirements such as Saudi law, regulations, search warrants, subpoenas, court orders, or other legal processes.",
  },
  minors_privacy: {
    title: "Minor’s Privacy",
    content:
      "We are concerned about protecting the privacy of Minors. The Website is not directed to individuals that are under the age, and we do not knowingly collect Personal Information from such individuals.",
  },
  changes_notice: {
    title: "Will We Inform You of Changes to This Privacy Notice?",
    content:
      "If we change this Privacy Notice, we will let you know about the changes by publishing the updated version at all applicable communication channels. Tamweel Aloula is committed to protecting and respecting your privacy.",
  },
  data_subject_choices: {
    title: "Rights Available to Owners of Personal Data",
    title_content:
      "Under Saudi Arabia's Personal Data Protection Law, the owners of personal data are entitled to the below rights. However, the rights to the data subject shall be disbursed in accordance with the regulatory and legal obligations incumbent upon Tamweel Aloula.",
    choice_1:
      "\tRight to request information on the processing activities carried out with their personal data.",
    choice_2: "\tRight to request access to their personal data.",
    choice_3: "\tRight to request provision of personal data.",
    choice_4:
      "\tRight to request correction, updating, or completion of their personal data.",
    choice_5: "\tRight to request erasure of personal data in specific cases.",
    choice_6: "\tRight to withdraw consent in specific cases.",
    content:
      "For any queries and complaints, you can send an email to “DPO@tamweel-aloula.com”” or use the complaint logging feature available on our website.",
  },
  data_access_correction: {
    title:
      "Methods For Accessing, Correcting, Or Modifying Personal Information",
    content:
      "If you believe any information on your personal credit report is inaccurate or incomplete, you can raise a dispute case and tell us specifically why you think it’s inaccurate or incomplete.\n" +
      "You can contact us for your query at “DPO@tamweel-aloula.com”” or use the complaint logging feature available on our website.\n",
  },
  UPLOAD_DOCUMENT: "Upload document",
  APPLY: "Apply",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  CLOSE: "Close",
  SUBMIT: "Submit",
  STEP_OFFER: "Offer",
  STEP_CONTRACT: "Contract",
  DISBURSEMENNT: "Disbursement",
  STEP_DONE: "Done",
  QARAR_COMMENTS: "Qarar Comments",
  SHARED: {
    SEARCH: "Search",
    ONE: "1",
    TWO: "2",
    THREE: "3",
    FOUR: "4",
  },
  PROVIDERS: {
    PROVIDERS: "Providers",
    SUBMIT_APPL_SUCEESS: "Application Submitted successfully.",
    SUBMIT_APPL_ERROR: "Failed. Please try again.",
    NO_DATA_FOUND: "No Data Found",
  },
  VOUCHERS: {
    VOUCHERS: "Vouchers",
    SHERIZERO_PT1: "0% Profit Rate",
    SHERIZERO_PT2: "Provide you access to more than",
    SHERIZERO_PT4: "4 to 12 months tenure",
    FIVE_THOUSAND: "5000",
    STARTS_FROM: "Starts from",
    APPLY_NOW: "Apply now",
    COMING_SOON: "Coming soon",
    EIGHTY_FIVE_MERCHANTS: "85 merchants",
    FOUR_HUNDRED_MERCHANTS: "400 merchants",
    FILL_FORM: "PLEASE FILL OUT THE FOLLOWING FORM",
    SHERI_PT1: "APR starts from 15.08%",
    SHERI_PT2: "From 6 to 60 Months tenure",
    MAX_LIMIT: "Max amount",
    FIVE_HUNDRED_THOUSAND: "500,000",
  },
  MERCHANTS: {
    BEST_SELLERS: "Best Sellers",
    PROVIDERS: "Providers",
    ALL_CARDS: "Merchants",
    SEARCH_BY_NAME: "Search Merchants by name",
  },
  PRE: {
    WELCOME: "Welcome to Tamweel!",
    DESCRIPTION: "Follow these steps to finalize profile setup:",
    STARTED: "Follow these steps to finalize profile setup:",
    PERSONAL_DATA_HEADING: "Follow these steps to finalize profile setup:",
    PERSONAL_DATA_DESCRIPTION: "Manage your Name and ID Number... etc:",
    ADDRESS_DTL_HEADING: "Address Details",
    ADDRESS_DTL_DESCRIPTION: "Manage your Residence place",
    MARITAL_STATUS_HEADING: "Marital Status",
    MARITAL_STATUS_DESCRIPTION:
      "Manage your Marital Status and dependents Number",
    ELIGIBILITY_HEADING: "Eligibility",
    ELIGIBILITY_DESCRIPTION: "Manage your Employment and payment details",
  },
};

export default locale;
